import React from 'react';
import { Checkbox } from 'react-icheck';
import 'icheck/skins/minimal/grey.css';
import { withTranslation } from 'react-i18next';

const PaymentCategoryPopover = ({ className, style, categories, selectedCategories, onChange, disabled, t }) => {
	const itemStyle = {
		display: 'block',
		padding: '6px 20px',
		clear: 'both',
		fontSize: '14px',
		color: '#333',
		whiteSpace: 'nowrap'
	};

	const checkedValues = new Set(selectedCategories || []);
	const categoryOnChange = (id, checked) => {
		if (checked) {
			checkedValues.add(id);
		} else {
			checkedValues.delete(id);
		}
		onChange([...checkedValues]);
	};

	return <div
		className={className}
		style={{
			...style,
			position: 'absolute',
			zIndex: 2000,
			backgroundColor: '#FFF',
			boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
			border: '1px solid #CCC',
			borderRadius: 4,
			marginTop: 5,
			padding: 5,
			maxWidth: 600
		}}>
		<ul style={{ padding: '5px 0', marginBottom: 0 }}>
			{categories.map(x => <li key={x.id} style={itemStyle}><Checkbox checkboxClass='icheckbox_minimal-grey bg' disabled={disabled}
				label={t(`PaymentCategory_${x.name}`)}
				checked={checkedValues.has(x.id)}
				onChange={e => categoryOnChange(x.id, e.target.checked)}
			/>
			</li>)}
		</ul>
	</div>;
};

export default withTranslation()(PaymentCategoryPopover);